import React, { useState, useEffect, useContext } from "react";
import api from "../../../API/axiosInstance";
import { Pagination } from "@mui/material";

import "../../../styles/datacards.css";
import CardsModal from "./CardsModal";
import nodata from "../../../images/nodata2.png";
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Button,
  OutlinedInput,
  ListItemText,
  Skeleton,
  Grid,
  Box,
} from "@mui/material";
import { useParams } from "react-router-dom";
import BasicDateTimeRangePicker from "../../Filters/DateTimeRange";
import dayjs from "dayjs";
import { MyContext } from "../../../MyContextApi";
import NavBar from "../../Admin/Dashboard/NavBar";
import { generateHash } from "../../../API/hashUtil";
import ReactProSidebar from "../../Admin/Dashboard/ReactProSidebar";
// import RangeSlider from "../../GeneratePdf/RangeSlider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSquareFacebook,
  faYoutube,
  faInstagram,
  faTiktok,
  faSquareXTwitter,
  faGolang,
  faSquareThreads,
  faReddit,
} from "@fortawesome/free-brands-svg-icons"; // Import the icons
import Tooltip from "@mui/material/Tooltip";
import {
  faArrowTrendUp,
  faArrowTrendDown,
} from "@fortawesome/free-solid-svg-icons";
import IconButton from "@mui/material/IconButton";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
const DataCardsChild = ({ data }) => {
  let stringParams = "";
  const {
    toggleButton,
    sidebarPlatformName,
    setsidebarPlatformName,
    rangeValues,
    selectedRange,
    setSelectedRange,
  } = useContext(MyContext);
  const [navigationCount, setNavigationCount] = useState("1");
  const [openModal, setOpenModal] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [fromDateTimeFormatted, setFromDateTimeFormatted] = useState(null);
  const [toDateTimeFormatted, setToDateTimeFormatted] = useState(null);
  const [selectedPlatforms, setSelectedPlatforms] = useState("ALL");
  const [filteredData, setFilteredData] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true); // Loading state
  const [clearDates, setClearDates] = useState(false);
  const token = localStorage.getItem("Token");
  const platforms = [
    { value: "FACEBOOK", label: "Facebook" },
    { value: "TWITTER", label: "Twitter" },
    { value: "YOUTUBE", label: "YouTube" },
    { value: "INSTAGRAM", label: "Instagram" },
    { value: "THREADS", label: "Threads" },
    { value: "ALL", label: "All" },
  ];
  const getCardsData = async (platform, startDate, endDate, query) => {
    setLoading(true); // Start loading

    stringParams = {
      startDateStr: startDate ? startDate.toString() : "",
      endDateStr: endDate ? endDate.toString() : "",
      platforms: platform ? platform.toString() : "",
      searchQuery: query ? query.toString() : "",
    };

    const hexHash = generateHash(stringParams);
    try {
      const response = await api.get(`/api/filter`, {
        params: {
          platforms: platform,
          startDateStr: startDate,
          endDateStr: endDate,
          // searchQuery: query,
          HPPcode: hexHash,
        },

        headers: {
          // Security Headers
          "X-XSS-Protection": "1; mode=block",
          Authorization: `Bearer ${token}`,
          "X-Content-Type-Options": "nosniff",
          "X-Frame-Options": "DENY",
          "Referrer-Policy": "strict-origin-when-cross-origin",
          "Permissions-Policy": "camera=(), microphone=(), geolocation=()",

          // Standard Headers
          "Content-Type": "application/json",
        },
      });

      // Sort data by dateCreated in descending order (latest first)
      const sortedData = [...response.data].sort(
        (a, b) =>
          new Date(b.crawlTime).getTime() - new Date(a.crawlTime).getTime()
      );
      setFilteredData(sortedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // End loading
    }
  };

  useEffect(() => {
    getCardsData(selectedPlatforms, fromDateTimeFormatted, toDateTimeFormatted);
  }, []);

  const handlePlatformChange = (event) => {
    setSelectedPlatforms(event.target.value);
  };

  const handleFromDateTimeChange = (fromDateTime) => {
    const formattedFromDateTime = dayjs(fromDateTime).format(
      "YYYY-MM-DDTHH:mm:ss[Z]"
    );
    setFromDateTimeFormatted(formattedFromDateTime);
  };

  const handleToDateTimeChange = (toDateTime) => {
    const formattedToDateTime = dayjs(toDateTime).format(
      "YYYY-MM-DDTHH:mm:ss[Z]"
    );
    setToDateTimeFormatted(formattedToDateTime);
  };
  const handleClearDates = () => {
    setClearDates(true);

    // After clearing, immediately set back to false, otherwise next button click won't trigger useEffect
    setTimeout(() => {
      setClearDates(false);
    }, 0);
  };
  const handleGoClick = () => {
    getCardsData(
      selectedPlatforms,
      fromDateTimeFormatted,
      toDateTimeFormatted,
      searchQuery
    );
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;

  const truncatePost = (content) => {
    if (content.length > 30) {
      return content.substring(0, 140);
      // + "...";
    }
    return content;
  };

  const totalPages = filteredData
    ? Math.ceil(filteredData.length / itemsPerPage)
    : 0;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const currentData = filteredData
    ? filteredData.slice(startIndex, endIndex)
    : [];

  return (
    <div className="container">
      <NavBar />
      <main
        className={`data-card-container ${
          toggleButton ? "cardplatformshow" : "cardplatformhide"
        }`}
      >
        <div
          className="card-filter-section"
          id="card-filters"
          style={{
            display: "flex",
            flexWrap: "nowrap",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: "10px",
            margin: "15px",
            paddingBottom: "4px",
          }}
        >
          <FormControl sx={{ m: 1, minWidth: 200 }}>
            <InputLabel id="platform-select-label">Select Platform</InputLabel>
            <Select
              labelId="platform-select-label"
              value={selectedPlatforms}
              onChange={handlePlatformChange}
              input={<OutlinedInput label="Select Platform" />} // Adjusting height here
              renderValue={(selected) =>
                platforms.find((p) => p.value === selected)?.label || "All"
              }
              sx={{
                height: "43px",
                width: "150px",
                marginTop: "3px",
                marginBottom: "-5px",
                backgroundColor: "#ffffff", // White input background
                borderRadius: "8px", // Rounded corners for input
              }} // Adjusting the height for the Select element
            >
              {platforms.map((platform) => (
                <MenuItem key={platform.label} value={platform.value}>
                  <ListItemText primary={platform.label} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <div style={{ marginLeft: "-60px" }}>
            <BasicDateTimeRangePicker
              onFromDateTimeChange={handleFromDateTimeChange}
              onToDateTimeChange={handleToDateTimeChange}
              fromDateTimeFormatted={fromDateTimeFormatted}
              toDateTimeFormatted={toDateTimeFormatted}
              clearDates={clearDates}
            />
          </div>
          <Tooltip title="Reset Filters" arrow>
            <IconButton
              aria-label="reset filters"
              onClick={handleClearDates}
              sx={{
                color: "#ffffff",
                backgroundColor: "#5356ff", // Blue 600
                borderRadius: "25px",
                padding: "10px",
                boxShadow: "0 2px 4px rgba(37, 99, 235, 0.2)",
                transition: "all 0.2s ease-in-out",
                marginTop: "4px",
                "&:hover": {
                  backgroundColor: "#4244cc", // Blue 700
                  boxShadow: "0 4px 8px rgba(37, 99, 235, 0.3)",
                  transform: "translateY(-1px)",
                },
                "&:active": {
                  backgroundColor: "#1e40af", // Blue 800
                  transform: "translateY(0px)",
                  boxShadow: "0 2px 4px rgba(37, 99, 235, 0.2)",
                },
              }}
            >
              <RestartAltIcon />
            </IconButton>
          </Tooltip>
          <Button
            variant="contained"
            onClick={handleGoClick}
            className="linkbutton"
            style={{
              marginTop: "5px",
              marginLeft: "5px",
              backgroundColor: "#ffffff",
              border: "2px solid #615EFC",
              // background: "linear-gradient(135deg, #0077ff, #00d4ff)",
              // Gradient color
              color: "#fff", // White icon color
              padding: "20px 20px",
              borderRadius: "50px", // Full rounded corners
              boxShadow: "0px 4px 8px rgba(114, 90, 193, 0.3)", // Soft shadow with #615EFC

              transition: "transform 0.2s, box-shadow 0.2s", // Animation on hover
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = "scale(1.05)";
              e.currentTarget.style.boxShadow =
                "0px 4px 8px rgba(114, 90, 193, 0.4)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow =
                "0px 4px 8px rgba(114, 90, 193, 0.3)";
            }}
          >
            <FontAwesomeIcon
              icon={faGolang}
              style={{
                fontSize: "30px", // Adjust icon size
                marginLeft: "-6px",
                color: "#615EFC",
              }}
            />
          </Button>
        </div>

        {openModal && (
          <CardsModal
            cardData={selectedCard}
            open={openModal}
            handleClose={handleCloseModal}
          />
        )}

        {loading ? (
          <>
            <div className="cards-section">
              {[...Array(currentData.length || 12)].map((_, index) => (
                <Box
                  key={index}
                  sx={{
                    width: "53vh",
                    height: "270px",
                    borderRadius: "20px",
                    // backgroundImage:
                    //   "radial-gradient(circle at 10% 20%, rgb(230, 232, 255) 0%, rgb(235, 235, 255) 33.1%, rgb(245, 240, 255) 90%)",
                    marginTop: "10px",
                    position: "relative",
                    padding: "1.2rem",
                    border: "2.5px solid #c3c6ce",
                    boxShadow: "0 0px 10px 0 rgba(0, 0, 0, 0.25)",
                    overflow: "visible",
                  }}
                >
                  {/* Image Skeleton */}
                  <Skeleton
                    variant="circular"
                    width={80}
                    height={80}
                    animation="wave"
                    sx={{ marginBottom: "1rem" }}
                  />
                  {/* Title Skeleton */}

                  {/* Subtitle/Multiple Lines Skeleton */}
                  <Skeleton
                    variant="text"
                    width="90%"
                    height={20}
                    animation="wave"
                    sx={{ marginBottom: "0.5rem" }}
                  />
                  <Skeleton
                    variant="text"
                    width="100%" // Wider line toward the right side
                    height={20}
                    animation="wave"
                    sx={{ marginBottom: "0.5rem" }}
                  />
                  <Skeleton
                    variant="text"
                    width="85%" // Another line reaching the right
                    height={20}
                    animation="wave"
                    sx={{ marginBottom: "0.5rem" }}
                  />
                  <Skeleton
                    variant="text"
                    width="95%" // Extended right-line to match the design
                    height={20}
                    animation="wave"
                  />
                </Box>
              ))}
            </div>
          </>
        ) : (
          <div className="cards-section">
            {currentData && currentData.length > 0 ? (
              currentData.map((item, index) => (
                <div className="data-card" key={index}>
                  <div className="data-card-content">
                    <div className="data-card-top">
                      <h3
                        className="data-card-owner"
                        style={{ marginBottom: "12px" }}
                      >
                        {item.useHandle ? (
                          <a
                            href={item.useHandle}
                            target="_blank"
                            rel="noopener noreferrer"
                            // style={{
                            //   textDecoration: "none", // Remove underline
                            //   color: "inherit", // Inherit color from parent or CSS
                            //   fontWeight: "bold", // Optional: Make it more prominent
                            // }}
                          >
                            {truncatePost(item.postOwner || "N/A", 4)}
                            {/* {item.postOwner || "N/A"} */}
                          </a>
                        ) : (
                          item.postOwner || "N/A"
                        )}
                      </h3>

                      <div className="data-platform-icon-child">
                        <p>
                          {item.platform === "FACEBOOK" ? (
                            <FontAwesomeIcon
                              icon={faSquareFacebook}
                              style={{ color: "#1877f2", fontSize: "33px" }}
                            />
                          ) : item.platform === "TWITTER" ? (
                            <FontAwesomeIcon
                              icon={faSquareXTwitter}
                              style={{ fontSize: "33px" }}
                            />
                          ) : item.platform === "YOUTUBE" ? (
                            <FontAwesomeIcon
                              icon={faYoutube}
                              style={{ color: "#ff0000", fontSize: "33px" }}
                            />
                          ) : item.platform === "INSTAGRAM" ? (
                            <FontAwesomeIcon
                              icon={faInstagram}
                              style={{ color: "#e1306c", fontSize: "33px" }}
                            />
                          ) : item.platform === "THREADS" ? (
                            <FontAwesomeIcon
                              icon={faSquareThreads}
                              style={{ color: "#000000", fontSize: "33px" }}
                            />
                          ) : item.platform === "REDDIT" ? (
                            <FontAwesomeIcon
                              icon={faReddit}
                              style={{ color: "#FF5700", fontSize: "33px" }}
                            />
                          ) : (
                            "N/A"
                          )}
                        </p>
                      </div>
                    </div>
                    <div className="data-content">
                      <strong
                        className="data-keywords"
                        style={{
                          // backgroundColor: "#C2FFC7", // light green background
                          borderRadius: "8px",
                          // padding: "8px",
                          marginBottom: "12px",
                        }}
                      >
                        Keywords: {"       "}
                        {/* <br /> */}
                        {item.keyword && (
                          <span
                            // className={isExpanded ? "" : "one-line"}
                            // className="one-line"
                            style={{ color: "#8B5DFF" }}
                          >
                            {item.keyword}
                          </span>
                        )}
                      </strong>
                      {
                        <div
                          className="data-content-child"
                          style={{ marginBottom: "10px" }}
                        >
                          <strong>Post:</strong> 
                          <span className="data-content-child-value-span">
                            {item.platform === "YOUTUBE"
                              ? truncatePost(item.title || "N/A", 800)
                              : truncatePost(item.content || "N/A", 400)}
                          </span>
                        </div>
                      }
                      {item.intensity && (
                        <div className="data-content-child">
                          <strong>Intensity:</strong> 
                          <span className="data-content-child-value">
                            {item.intensity}
                          </span>
                          {item.intensity === "high" ? (
                            <FontAwesomeIcon
                              icon={faArrowTrendUp}
                              style={{ marginLeft: "5px", color: "red" }}
                            />
                          ) : item.intensity === "high" ? (
                            <FontAwesomeIcon
                              icon={faArrowTrendUp}
                              style={{ marginLeft: "5px", color: "red" }}
                            />
                          ) : (
                            <FontAwesomeIcon
                              icon={faArrowTrendDown}
                              style={{ marginLeft: "5px", color: "green" }}
                            />
                          )}
                        </div>
                      )}
                      {item.datetime && (
                        <div className="data-content-child">
                          <strong>Date & Time:</strong> 
                          <span
                            className="data-content-child-value"
                            style={{ color: "#024CAA", fontWeight: "800px" }}
                          >
                            {new Intl.DateTimeFormat("en-GB", {
                              day: "2-digit",
                              month: "short",
                              year: "2-digit",
                              timeZone: "UTC", // avoids local timezone conversion
                            }).format(new Date(item.datetime))}
                            , 
                            {new Intl.DateTimeFormat("en-GB", {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                              timeZone: "UTC", // avoids local timezone conversion
                            }).format(new Date(item.datetime))}
                          </span>
                        </div>
                      )}
                    </div>

                    <a
                      href="#"
                      className="card-button"
                      onClick={() => {
                        setSelectedCard(item);
                        setOpenModal(true);
                      }}
                    >
                      More Info
                    </a>
                  </div>
                </div>
              ))
            ) : (
              <div
                style={{
                  width: "160vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  // Ensures that the parent div takes full height of the viewport
                }}
              >
                <img
                  alt="nodata"
                  src={nodata}
                  style={{
                    width: "75vh",
                  }}
                />
              </div>
            )}
          </div>
        )}

        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(event, value) => setCurrentPage(value)}
          color="primary"
          sx={{
            marginBottom: "13px",
            marginTop: "10px",
            marginRight: "30px",
            display: "flex",
            justifyContent: "center",
            "& .MuiPaginationItem-root": {
              backgroundColor: "#E8F2FF", // Very light blue for unselected buttons
              color: "#1A365D", // Dark blue-gray text for contrast
              border: "1px solid #B8D4F0", // Light blue border
              "&:hover": {
                backgroundColor: "#D1E7FF", // Slightly darker light blue on hover
                borderColor: "#3572EF", // Main blue border on hover
              },
            },
            "& .Mui-selected": {
              backgroundColor: "#3572EF", // Main blue for the selected button
              color: "#FFFFFF", // White text for the selected button
              borderRadius: "50%", // Circular selected button
              fontWeight: "bold", // Make it visually distinct
              border: "1px solid #3572EF", // Main blue border
              "&:hover": {
                backgroundColor: "#2563EB", // Slightly darker blue for hover effect on the selected button
              },
            },
            "& .MuiPaginationItem-previousNext": {
              backgroundColor: "#F0F7FF", // Very light blue for prev/next buttons
              color: "#3572EF", // Main blue text
              "&:hover": {
                backgroundColor: "#E0EFFF", // Light blue on hover
              },
            },
            "& .MuiPaginationItem-firstLast": {
              backgroundColor: "#F0F7FF", // Very light blue for first/last buttons
              color: "#3572EF", // Main blue text
              "&:hover": {
                backgroundColor: "#E0EFFF", // Light blue on hover
              },
            },
          }}
          showFirstButton
          showLastButton
        />
      </main>
      {/* <SideBar /> */}
      <ReactProSidebar />
    </div>
  );
};

export default DataCardsChild;
